module.exports = __webpack_public_path__ + "img/HT-M01.6ce8b441.jpg";